export enum OAuth2IdentityProviders {
    GIFAS = 'GIFAS',
    CETIM = 'CETIM',
    PSI = 'PSI',
    IKIGAI = 'IKIGAI',
    DELFINGEN = 'JUMPCLOUD',
}
